<template>
  <div
    v-if="offersData.offerList.length"
    class="label margin-bottom-m"
  >
    <button
      :class="{
        'loyallist-offer-badge': offersData.topOffer.isLoyallistOffer,
      }"
      class="h6 offer-badge"
      type="button"
      name="button"
      @click="scrollIntoMembers"
    >
      offers available—see below
    </button>
  </div>
</template>

<script setup>
import { getOffersData } from '@common-vue/media-card-large/src/modules/price/composables/utils.bcom';
import { useProduct } from '@modules/product';

const { productData } = useProduct();

const badgeData = productData.pricing || {};

const offersData = getOffersData(badgeData, {});

const scrollIntoMembers = (e) => {
  /** @type {HTMLElement | null} */
  const membersOfMaster = document.getElementById('members-of-master');
  if (membersOfMaster) {
    e.target.blur();
    membersOfMaster.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }
};
</script>

<style lang="scss" scoped>
.loyallist-offer-badge.offer-badge {
  background: $loyalty-1-color;
  color: $white;
}

.offer-badge {
  margin: 0;
  padding: rem-calc(10 15);
  height: auto;
  background: $promotions-color;
  color: $black;
  border: none;
  line-height: 1.5;
  text-align: left;
  min-height: rem-calc(18);
  cursor: pointer;
}
</style>
